 

export default{
    state: {  
      toolbar: {
        tbShow: true,
        tbFlat: false, 
        tbColor:'primary'
      },
      notHeader: {
        notShow: true,
        notType: false,
        notHeight: '500',
        notText: true,
        notIcon: false,
        notIndicators: false,
        notImages:"",
        notAction: ''
      },
      snackBar: {
        snShow: false,
        snTime: 6000,
        snTx: 'testing',
        snX: null,
        snY: 'bottom',
        snMode: ''
      },
      notDialog: {
        notShow: false,
        notHd: false,
        notH: '',
        notTx: '',
        notYesTx: '',
        notNoTx: '',
        notAction: ''
      },
      notDialogP: {
        notShow: false, 
        notHd: true,
        notTx: '',
        notCl: 'primary'
      }, 
      notResponse:{
        not:false,
        notAction:null,
        notRes:null
      }
    },
    //___________________-GETTERS-_________________
    getters: { 
        //---not
        getToolbar(state) {
          return state.toolbar
        },
        getNotHeader(state){
          return state.notHeader
        },
        getNotSnack(state) {
          return state.snackBar
        },
        getNotDialog(state) {
          return state.notDialog
        },
        getNotDialogP(state) {
          return state.notDialogP
        },  
        getNotResponse(state){
          return state.notResponse
        }
    },
    //___________________-MUTATIONS-___________________
    mutations:{ 
      updateToolbar(state, payload) {
        state.toolbar = payload  
      },
      updateNotHeader(state,payload){
        state.notHeader = payload
      }, 
      updateSnackBar(state, payload) {
        state.snackBar = payload
      },
      updateNotDialog(state, payload) {
        state.notDialog = payload
      },
      updateNotDialogP(state, payload) {
        state.notDialogP = payload
      }, 
    },
    //____________________-ACTIONS-_____________________
    actions: {  
        setNotResponse({state},payload){
          let not = false
          let notAction = null
          let notRes = null
          if (payload.not) {
            not = payload.not
          }
          if (payload.notAction) {
            notAction = payload.notAction
          }
          if (payload.notRes) {
              notRes = payload.notRes
          }
          state.notResponse ={
            not:not,
            notAction:notAction,
            notRes:notRes
          }
        },
        setNotSnack({ commit }, payload) {
          let snShow = false
          let snTime = 6000
          let snTx = ''
          let snX = null
          let snY = 'bottom'
          let snMode = ''

          if (payload.snShow != undefined) {
            snShow = payload.snShow
          }
          if (payload.snTime != undefined) {
            snTime = payload.snTime
          }
          if (payload.snTx != undefined) {
            snTx = payload.snTx
          }
          if (payload.snX != undefined) {
            snX = payload.snX
          }
          if (payload.snY != undefined) {
            snY = payload.snY
          }
          if (payload.snMode != undefined) {
            snMode = payload.snMode
          }

          let newSnack = {

            snShow: snShow,
            snTime: snTime,
            snTx: snTx,
            snX: snX,
            snY: snY,
            snMode: snMode
          }
          //console.log(newSnack)
          commit('updateSnackBar', newSnack)
        },
        setNotDialog({ commit }, payload) {
          let notShow = false,
            notHd = false,
            notH = '',
            notTx = '',
            notYesTx = '',
            notNoTx = '',
            notAction = ''

          if (payload.notShow != undefined) {
            notShow = payload.notShow
          }
          if (payload.notHd != undefined) {
            notHd = payload.notHd
          }
          if (payload.notH != undefined) {
            notH = payload.notH
          }
          if (payload.notTx != undefined) {
            notTx = payload.notTx
          }
          if (payload.notYesTx != undefined) {
            notYesTx = payload.notYesTx
          }
          if (payload.notNoTx != undefined) {
            notNoTx = payload.notNoTx
          }
          if (payload.notAction != undefined) {
            notAction = payload.notAction
          }

          let newNotDialog = {
            notShow: notShow,
            notHd: notHd,
            notH: notH,
            notTx: notTx,
            notYesTx: notYesTx,
            notNoTx: notNoTx,
            notAction: notAction
          }
          //console.log(newNotDialog)
          commit('updateNotDialog', newNotDialog)
        },
        setNotDialogP({ commit }, payload) {
          let notShow = false,
            notHd = true,
            notTx = '',
            notCl = 'primary'

          if (payload.notShow != undefined) {
            notShow = payload.notShow
          }
          if (payload.notHd != undefined) {
            notHd = payload.notHd
          }
          if (payload.notTx != undefined) {
            notTx = payload.notTx
          }
          if (payload.notCl != undefined) {
            notCl= payload.notCl
          }
          

          let newNotDialog = {
            notShow: notShow,
            notHd: notHd,
            notTx: notTx,
            notCl: notCl,
            
          }
          
          commit('updateNotDialogP', newNotDialog)
        },
        setNotHeader({commit,state}, payload){
          let oldNot = state.notHeader
          let not = { 
            notShow: payload.notShow == null || payload.notShow == undefined ? oldNot.notShow : payload.notShow,
            notType: payload.notType == null || payload.notType == undefined? oldNot.notType : payload.notType,
            notHeight: payload.notHeight == null || payload.notHeight == undefined? oldNot.notHeight : payload.notHeight,
            notText: payload.notText == null || payload.notText == undefined? oldNot.notHeight : payload.notText,
            notIcon: payload.notIcon === null || payload.notIcon === undefined? oldNot.notIcon : payload.notIcon,
            notIndicators: payload.notIndicators == null || payload.notIndicators == undefined? oldNot.notIndicators : payload.notIndicators,
            notImages: payload.notImages == undefined? null : payload.notImages,
            notAction: payload.notAction == null || payload.notAction == undefined? oldNot.notAction : payload.notAction 
          } 
          commit('updateNotHeader',not) 
        },
        setToolbar({ commit }, payload) {

          let oldTB = {
            tbShow: true,
            tbFlat: false, 
            tbColor:'primary'
          }
    
          let newToolbar = {
            tbShow: payload.tbShow == null || payload.tbShow == undefined ? oldTB.tbShow : payload.tbShow, 
            tbFlat: payload.tbFlat == null || payload.tbFlat == undefined ? oldTB.tbFlat : payload.tbFlat, 
            tbColor: payload.tbColor == null || payload.tbColor == undefined ? oldTB.tbColor : payload.tbColor
          }
          //console.log(newToolbar)
          commit('updateToolbar', newToolbar)
        }, 
        setToolbarColor({state},payload){
          state.toolbar.tbColor = payload
        }
         
    },
}